export default __webpack_public_path__ + "static/media/vox-img-legacy-020.27e95b13.jpg";